import { EnumDictionary } from '../../../shared/enums/enum-dictionary';

export enum Roles {
	Member = "Member",
	Admin = "Admin",
	SuperAdmin = "SuperAdmin",
	ClientAdmin = "ClientAdmin",
	PendingUser = "PendingUser",
	TenantAdmin = "TenantAdmin"

}

export const RolesMap: EnumDictionary<Roles, number> = {
	[Roles.Member]: 1,
	[Roles.Admin]: 2,
	[Roles.SuperAdmin]: 3,
	[Roles.ClientAdmin]: 4,
	[Roles.PendingUser]: 5,
	[Roles.TenantAdmin]: 6
};